import axios from 'axios';
import gql from 'graphql-tag';

const GET_SHIPMENT_RATES = gql`
  query getShipmentRates($shipmentDetail: GetShipmentRateInput!) {
    getShipmentRate(shipmentDetail: $shipmentDetail) {
      mode
      cost
      duration
      currency
    }
  }
`;

const GET_SHOPNSHIP_RATES = gql`
  query getShopnshipRates($input: GetShopnshipRatesInput!) {
    getShopnshipRates(input: $input) {
      mode
      cost
      actualCost
      remoteAreaCost
      duration
      currency
      pricingTier
      isDisabled
      isRecommended
      budgetDeliveryCost
      foreignExchangeCost
      foreignExchangeRate
      foreignExchangeCurrency
      tags
    }
  }
`;

const GET_COUNTRIES = gql`
  query {
    getCountries {
      code
      name
    }
  }
`;

const GET_STATES = gql`
  query getStates($countryCode: String!) {
    getStates(countryCode: $countryCode) {
      name
      countryCode
    }
  }
`;

const GET_CITIES = gql`
  query getCities($countryCode: String!) {
    getCities(countryCode: $countryCode) {
      cityName
      postcode
    }
  }
`;

const GET_CITIES_QUERY = async params => {
  const { countryCode, cityName } = params;
  return await axios.get(
    `${process.env.REACT_APP_REST_API}?city=${cityName || 'a'}&countryCode=${
      countryCode || 'NG'
    }`
  );
};

const CHAT_QUERY = gql`
  query chat($input: ChatInput!) {
    chat(input: $input) {
      message
      trackingId
      tracks {
        id
        status
      }

      shipmentDetail {
        senderDetails {
          cityName
          countryCode
          postalCode
        }
        receiverDetails {
          cityName
          countryCode
          postalCode
        }
      }

      rates {
        mode
        cost
      }
      recommendedLink
    }
  }
`;

const GET_ITEM_CATEGORIES = gql`
  query getItemCategories($variables: GetItemCategoriesInput!) {
    getItemCategories(input: $variables) {
      category
      value
      price
      currency
    }
  }
`;

const GET_EXPORT_LOCATION_DATA = gql`
  query {
    getExportLocationData {
      america {
        id
        name
        lat
        lng
        data {
          categories {
            name
            color
            value
          }
        }
      }
      europe {
        id
        name
        lat
        lng
        data {
          categories {
            name
            color
            value
          }
        }
      }
      asia {
        id
        name
        lat
        lng
        data {
          categories {
            name
            color
            value
          }
        }
      }
      africa {
        id
        name
        lat
        lng
        data {
          categories {
            name
            color
            value
          }
        }
      }
      oceania {
        id
        name
        lat
        lng
        data {
          categories {
            name
            color
            value
          }
        }
      }
    }
  }
`;

export {
  GET_SHIPMENT_RATES,
  GET_SHOPNSHIP_RATES,
  GET_COUNTRIES,
  GET_STATES,
  GET_CITIES,
  GET_CITIES_QUERY,
  CHAT_QUERY,
  GET_ITEM_CATEGORIES,
  GET_EXPORT_LOCATION_DATA
};
